import type { StockMovement } from "@/lib/stock.api";

export function formatMoney(value: string | number): string {
  const amount = typeof value === "number" ? value : parseFloat(value);
  return `${amount.toLocaleString("fr-FR")} XAF`;
}

export function formatDateTime(value: string): string {
  return new Date(value).toLocaleString("fr-FR");
}

export function formatMovementReference(movement: StockMovement): string {
  return movement.refType ? `${movement.refType} #${movement.refId ?? "-"}` : "-";
}
